import { AssociatedPersonnelThemeSizeConfig } from './types';

const medium: AssociatedPersonnelThemeSizeConfig = {
  associatedPersonnel: {},
};

export default medium;
